export default {
    refundRecord_00001: "Refund record",
    refundRecord_00002: "Refund date",
    refundRecord_00003: "refund amount({0})",
  }